import {  Box, Grid, } from "@mui/material";
import { CustomFormControl, IntegerOrEmptyFormControl } from "../../../../../../components/FormControl";
import { detailRowColumnWidths, entryTableFont } from "../../../style/salesRecordCollectiveEntryStyle";
import { grey } from "@mui/material/colors";
import { ON_INPUT_INVALID_INTEGER, validateInteger, validateIntegerOrEmpty } from "../../../../../../utils/validation";
import { inputValueToInt, inputValueToIntOrNull } from "../../../../../../utils/utils";
import RankSelect from "../../select/RankSelect";
import PackingSelect from "../../select/PackingSelect";
import ProductClassSelect from "../../select/ProductClassSelect";
import OriginSelect from "../../select/OriginSelect";
import { MinusButton, PlusButton } from "../../../../../../components/Buttons";

const validateAcceptanceLabelNo = (value, isNewEntry) => {
  return (isNewEntry && validateIntegerOrEmpty(value?.toString() || ""))
    || (!isNewEntry && validateInteger(value?.toString() || ""));
}

const createAcceptanceLabelNoHelperText = (value, isNewEntry) => {
  if (!validateIntegerOrEmpty(value?.toString() || "")) {
    return ON_INPUT_INVALID_INTEGER;
  }
  if (!isNewEntry && value == null) {
    return "既存販売原票の送り状番号は空にできません";
  }

  return "";
}

const validatePartition = (value, isNewEntry) => 
  (isNewEntry && validateIntegerOrEmpty(value?.toString() || ""))
    || (!isNewEntry && validateInteger(value?.toString() || ""));

const createPartitionHelperText = (value, isNewEntry) => {
  if (!validateIntegerOrEmpty(value?.toString() || "")) {
    return ON_INPUT_INVALID_INTEGER;
  }
  if (!isNewEntry && value == null) {
    return "既存販売原票の仕切Noは空にできません";
  }

  return "";
}

const validateQuantity = (value, isNewEntry) => {
  return (isNewEntry && validateIntegerOrEmpty(value?.toString() || ""))
    || (!isNewEntry && validateInteger(value?.toString() || ""));
}

const createQuantityHelperText = (value, isNewEntry) => {
  if (!validateIntegerOrEmpty(value?.toString() || "")) {
    return ON_INPUT_INVALID_INTEGER;
  }
  if (!isNewEntry && value == null) {
    return "既存販売原票の数量は空にできません";
  }

  return "";
}

const validateValue = (detail, isNewEntry) => {
  return (
    validateAcceptanceLabelNo(detail.acceptanceLabelNo, isNewEntry)
      && validateIntegerOrEmpty(detail.weight?.toString() || '')
      && validateQuantity(detail.quantity, isNewEntry)
      && validateIntegerOrEmpty(detail.purchacePrice?.toString() || '')
      && validatePartition(detail.partition?.toString() || '', isNewEntry)
      && validateIntegerOrEmpty(detail.directorEmployeeId?.toString() || '')
  )
}

function EntryDetailRow ({detail, isNewEntry, isPastEntry, isFullDetails, changeValue, addDetail, deleteDetail, enabledDelete, selectOptions, keyHandler}) {

  const handleChangeValue = (propName) => (value) => {
    const newDetail = {...detail,
      [propName]: validateIntegerOrEmpty(value) ? inputValueToIntOrNull(value): value
    };

    changeValue({
      [propName]: validateIntegerOrEmpty(value) ? inputValueToIntOrNull(value): value,
      error: !validateValue(newDetail, isNewEntry)
    })
  };

  const handleSelectValue = (propName) => (value) => {
    const newDetail = {...detail,
      [propName]: value
    };

    changeValue({
      [propName]: value,
      error: !validateValue(newDetail, isNewEntry)
    })
  };

  const {origins, ranks, productClasses, packings} = selectOptions;

  const selectedOrigin = origins.find((origin) => origin.originId == detail.originId);
  const selectedRank = ranks.find((rank) => rank.rankId == detail.rankId);
  const selectedProductClass = productClasses.find((prodCls) => prodCls.productClassId == detail.productClassId);
  const selectedPacking = packings.find((packing) => packing.packingId == detail.packingId);

  const handleClickAddDetail = (_e) => {
    addDetail();
  }

  const handleClickDeleteDetail = (_e) => {
    deleteDetail();
  }

  return (
    <Box py={1} borderTop={detail.detailIndex > 0 ? `1px ${grey[200]} solid` : null}>
      <Grid container columnSpacing={2} alignItems="center">
        <Grid item sx={{...detailRowColumnWidths.plusButton, ...entryTableFont}}>
          <PlusButton
            onClick={handleClickAddDetail}
            disabled={isPastEntry || isFullDetails}
          />
        </Grid>
        <Grid item sx={{...detailRowColumnWidths.minusButton, ...entryTableFont}}>
          <MinusButton
            onClick={handleClickDeleteDetail}
            disabled={isPastEntry || !enabledDelete}
          />
        </Grid>
        <Grid item sx={{...detailRowColumnWidths.origin, ...entryTableFont}}>
          <OriginSelect
            value={selectedOrigin}
            onSelect={(v) => handleSelectValue("originId")(v.originId)}
            origins={origins}
            width="100px"
            disabled={!isNewEntry}
          />
        </Grid>
        <Grid item sx={{...detailRowColumnWidths.rank, ...entryTableFont}}>
          <RankSelect
            value={selectedRank}
            onSelect={(v) => handleSelectValue("rankId")(v.rankId)}
            ranks={ranks}
            width="100px"
            disabled={isPastEntry}
          />
        </Grid>
        <Grid item sx={{...detailRowColumnWidths.productClass, ...entryTableFont}}>
          <ProductClassSelect
            value={selectedProductClass}
            onSelect={(v) => handleSelectValue("productClassId")(v.productClassId)}
            productClasses={selectOptions.productClasses}
            width="100px"
            disabled={isPastEntry}
          />
        </Grid>
        <Grid item sx={{...detailRowColumnWidths.packing, ...entryTableFont}}>
          <PackingSelect
            value={selectedPacking}
            onSelect={(v) => handleSelectValue("packingId")(v.packingId)}
            packings={selectOptions.packings}
            width="100px"
            disabled={isPastEntry}
          />
        </Grid>
        <Grid item sx={{...detailRowColumnWidths.supplyWeight, ...entryTableFont}}>
          {detail.supplyWeight? (detail.supplyWeight?.toString() || '') + (detail.weightUnitName || '') : ''}
        </Grid>
        <Grid item sx={{...detailRowColumnWidths.supplyUnitName, ...entryTableFont}}>
          {detail.supplyUnitName}
        </Grid>
        <Grid item sx={{...detailRowColumnWidths.supplyUnitQuantity, ...entryTableFont, textAlign: "right"}}>
          {detail.supplyUnitQuantity}
        </Grid>
        <Grid item sx={{...detailRowColumnWidths.supplyQuantity, ...entryTableFont, textAlign: "right"}}>
          {detail.supplyQuantity}
        </Grid>
        <Grid item sx={{...detailRowColumnWidths.acceptanceLabelNo}}>
          <CustomFormControl
            value={detail?.acceptanceLabelNo?.toString() || ''}
            setValue={handleChangeValue("acceptanceLabelNo")}
            error={!validateAcceptanceLabelNo(detail?.acceptanceLabelNo, isNewEntry)}
            helperText={createAcceptanceLabelNoHelperText(detail?.acceptanceLabelNo, isNewEntry)}
            helperTextSx={{mx: 0}}
            onBlurFormat={(v) => v}
            disabled={isPastEntry}
            inputProps={{sx:{textAlign: "right"}}}
            {...keyHandler.registerComponent(1)}
          />
        </Grid>
        <Grid item sx={{...detailRowColumnWidths.partition, ...entryTableFont}}>
          <CustomFormControl
            value={detail?.partition?.toString() || ''}
            setValue={handleChangeValue("partition")}
            error={!validatePartition(detail?.partition, isNewEntry)}
            helperText={createPartitionHelperText(detail?.partition, isNewEntry)}
            helperTextSx={{mx: 0}}
            onBlurFormat={(v) => v}
            disabled={isPastEntry}
            inputProps={{sx:{textAlign: "right"}}}
            {...keyHandler.registerComponent(2)}
          />
        </Grid>
        <Grid item sx={{...detailRowColumnWidths.weight}}>
          <IntegerOrEmptyFormControl
            value={detail?.weight?.toLocaleString() || ''}
            setValue={handleChangeValue("weight")}
            onBlurFormat={(v) => validateInteger(v) ? inputValueToInt(v).toLocaleString() : v}
            helperTextSx={{mx: 0}}
            disabled={isPastEntry}
            inputProps={{sx:{textAlign: "right"}}}
            {...keyHandler.registerComponent(3)}
          />      
        </Grid>
        <Grid item sx={{...detailRowColumnWidths.quantity}}>
          <IntegerOrEmptyFormControl
            value={detail?.quantity?.toLocaleString() || ''}
            setValue={handleChangeValue("quantity")}
            error={!validateQuantity(detail?.quantity, isNewEntry)}
            helperText={createQuantityHelperText(detail?.quantity, isNewEntry)}
            helperTextSx={{mx: 0}}
            onBlurFormat={(v) => validateInteger(v) ? inputValueToInt(v).toLocaleString() : v}
            disabled={isPastEntry}
            inputProps={{sx:{textAlign: "right"}}}
            {...keyHandler.registerComponent(4)}
          />
        </Grid>
        <Grid item sx={{...detailRowColumnWidths.purchacePrice}}>
          <IntegerOrEmptyFormControl
            value={detail?.purchacePrice?.toLocaleString() || ''}
            setValue={handleChangeValue("purchacePrice")}
            onBlurFormat={(v) => validateInteger(v) ? inputValueToInt(v).toLocaleString() : v}
            helperTextSx={{mx: 0}}
            disabled={isPastEntry}
            inputProps={{sx:{textAlign: "right"}}}
            {...keyHandler.registerComponent(5)}
          />
        </Grid>
        <Grid item sx={{...detailRowColumnWidths.directorEmployeeId, ...entryTableFont}}>
          <IntegerOrEmptyFormControl
            value={detail?.directorEmployeeId?.toString() || ''}
            setValue={handleChangeValue("directorEmployeeId")}
            helperTextSx={{mx: 0}}
            onBlurFormat={(v) => v}
            disabled={isPastEntry}
            inputProps={{sx:{textAlign: "right"}}}
            {...keyHandler.registerComponent(6)}
          />
        </Grid>        
      </Grid>
    </Box>
  )
}

export default EntryDetailRow;